import amapi from 'Api/amapi'
import { generateStr } from '@/helpers/helpers'

export async function makeWpLoginUrl ({ insid, username }) {
  const autoId = generateStr(32)
  const params = {
    method: `sign_on&insid=${insid}&autoid=${autoId}`,
    _username: username,
  }

  const response = await amapi.softaculous_api(params)
  if (!response.sign_on_url) {
    const errorMsg = response?.error ? Object.values(response.error).at(0) : 'Failed to get login URL.'
    throw new Error(errorMsg)
  }

  return response.sign_on_url
}
